<template>
  <div class="project">
    <ccs-header
      :title="project.name"
      :back="true"/>
    <div class="project-menu">
      <menu-tab v-for="(tab, index) in allowedTabs" :key="index"
        :to="tab.to" :text="tab.text" :params="tab.params" />
    </div>
    <div class="project-content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

import { PermissionsList } from '@/helpers/permissions';

import Header from '@/layouts/Header.vue';
import MenuTab from '@/components/MenuTab.vue';

export default {
  name: 'Project',
  components: {
    'ccs-header': Header,
    MenuTab,
  },
  computed: {
    ...mapState('misc', ['siteSettings']),
    ...mapState('projects', ['project']),
    ...mapState('session', ['permissions']),
    ...mapState('events', ['event']),
    allowedTabs() {
      return this.tabs.filter(tab => this.isAccessAllowed(tab.requiredPermissions));
    },
    tabs() {
      return [{
        text: 'Информация',
        to: 'project_info',
        requiredPermissions: [
          PermissionsList.ProjectViewAll,
          PermissionsList.ProjectView,
        ],
      }, {
        text: 'Контрольные точки',
        to: `project_control_points_${this.siteSettings.defaultControlPointsView}`,
        params: {
          page: 1
        },
        requiredPermissions: [
          PermissionsList.ControlPointViewAll,
          PermissionsList.ControlPointView,
        ],
      }];
    }
  },
  methods: {
    ...mapMutations('events', ['setEventID']),
    ...mapMutations('projects', ['setProjectID', 'resetProject']),
    ...mapActions('projects', ['getProject']),
    isAccessAllowed(requiredPermissions) {;
      let result = false;
      if (!requiredPermissions) {
        result = true;
        return result;
      } else {
        requiredPermissions.forEach(slug => {
          result = result || this.permissions[slug];
        });
        return result;
      }
    },
  },
  async created() {
    this.setProjectID(this.$route.params.projectID);
    await this.getProject();
  },
  beforeDestroy() {
    this.resetProject();
  }
};
</script>

<style lang="scss" scoped>
.project {
  min-height: 100%;
  min-width: 100%;
  background: $neutralLightest;

  &-content {
    padding: 25px 33px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background: #fff;
  }

  &-menu {
    margin: 0 33px 9px 33px;
  }

}
</style>
